import React from "react";
import "./Portfolio.css";
import UMaTPasQuoDB from "../../assets/images/projects/umat-past-questions.png";
import commentsSectionApp from "../../assets/images/projects/interactive-coments-section.png";
import houseMarketPlaceApp from "../../assets/images/projects/house-marketplace.png";
import githubFinderApp from "../../assets/images/projects/github-finder.png";
import feedbackApp from "../../assets/images/projects/feedback-app.png";
import { motion } from "framer-motion";
import { Project } from "../../components";

const projectsWrapperVariant = {
  hidden: {
    opacity: 0,
    transition: { when: "beforeChildren" },
  },
  show: {
    opacity: 1,
    transition: {
      duration: 1,
      staggerChildren: 0.5,
      delayChildren: 1,
    },
  },
};

const Portfolio = () => {
  return (
    <div id="portfolio">
      <h1>Portfolio</h1>
      <p>Here are a few projects I have worked on.</p>
      <motion.div
        variants={projectsWrapperVariant}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="projects"
      >
        <Project
          image={UMaTPasQuoDB}
          link="https://umat-past-questions.vercel.app/"
          description="UMaT Past Questions Database App"
        />
        <Project
          image={commentsSectionApp}
          link="http://interactive-coments-section.vercel.app/"
          description="Interactive Comments Section"
        />
        <Project
          image={houseMarketPlaceApp}
          link="http://house-marketplace-app-green.vercel.app/"
          description="House Marketplace App"
        />
        <Project
          image={githubFinderApp}
          link="https://github-finder-minoq.netlify.app/"
          description="GitHub Finder App"
        />
        <Project
          image={feedbackApp}
          link="https://feedback-app-minoq.netlify.app/"
          description="Feedback App"
        />
      </motion.div>
      <p>
        More projects{" "}
        <a
          className="emphasis"
          href="https://github.com/Quarcoo-arc"
          rel="noreferrer"
          target="_blank"
        >
          here
        </a>
        !
      </p>
    </div>
  );
};

export default Portfolio;
